import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from '../../../hooks';
import DesktopCredentialsCard from './DesktopCredentialsCard';
import MobileCredentialsCard from './MobileCredentialsCard';

const CredentialsCard = ({ onClick, avoidFingoDialog, DialogComponent, dialogProps, ...props }) => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      setOpen((prevState) => !prevState);
    }
  }, []);
  const CredentialCardComponent = isMobile ? MobileCredentialsCard : DesktopCredentialsCard;
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <>
      <CredentialCardComponent {...props} toggle={toggle} />
      {DialogComponent && (
      <DialogComponent
        open={open}
        setOpen={setOpen}
        onClose={handleClose}
        {...dialogProps}
      />
      )}
    </>
  );
};

CredentialsCard.propTypes = {
  onClick: PropTypes.func,
  avoidFingoDialog: PropTypes.bool,
  DialogComponent: PropTypes.func,
  dialogProps: PropTypes.shape({}),
};

CredentialsCard.defaultProps = {
  avoidFingoDialog: false,
  DialogComponent: null,
  onClick: null,
  dialogProps: {},
};

export default CredentialsCard;
